"use client"

import styled from "@emotion/styled"
import { useRef, useState } from "react"
import { Container, NewText, TabPanel, TzabarLineChart } from "ui"

import { sharedColors } from "ui/theme/colors"
import { extractProperty } from "utils"
import TzabarPie from "./TzabarPie"

// const StyledTabs = styled(Tabs)`
//   background-color: #f7f7f7;
//   border-radius: 200px;
//   padding: 8px;
//   .MuiButtonBase-root {
//     min-width: 150px;
//   }
//   .MuiTab-root {
//     color: #6f6f6f;
//     font-size: 18px;
//     font-style: normal;
//     font-weight: 400;
//     line-height: 28px;
//     padding-bottom: 0px;
//     border-bottom: 2px solid transparent;
//     width: 50%;
//   }
//   .Mui-selected {
//     color: ${sharedColors.black};
//     font-size: 18px;
//     font-style: normal;
//     font-weight: 600;
//     line-height: 28px;
//     background-color: white;
//     border-radius: 200px;
//   }
//   button {
//     padding: 0px;
//   }
//   ${(props) => props.theme.breakpoints.up("md")} {
//     margin-top: 0px;
//     width: 320px;
//   }
//   ${(props) => props.theme.breakpoints.down("sm")} {
//     width: 320px;
//   }
// `

const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  ${(props) => props.theme.breakpoints.down("sm")} {
    flex-direction: column;
  }
`

const StyledRightDiv = styled.div`
  p {
    margin-top: 16px;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    p {
      margin-top: 0px;
    }
  }
`

// const StyledLeftDiv = styled.div`
//   margin-top: 24px;
//   ${(props) => props.theme.breakpoints.up("md")} {
//     margin-top: 0px;
//   }
// `

const StyledWrapper = styled.div`
  padding-bottom: 32px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-bottom: 60px;
  }
`

// function a11yProps(index: number) {
//   return {
//     id: `full-width-tab-${index}`,
//     "aria-controls": `full-width-tabpanel-${index}`,
//   }
// }

type Props = {
  data: any
}

function TzabarGraph({ data }: Props) {
  const [value] = useState(0)
  const tooltipRef = useRef()
  // const t = useTranslations("TzabarGraph")

  // const handleChange = (event: React.SyntheticEvent, newValue: number) => {
  //   setValue(newValue)
  // }
  const title = extractProperty(data, "title")
  const textUnderTitle = extractProperty(data, "textUnderTitle")
  const pieGraphItems = extractProperty(data, "pieGraphItems")
  const commentLine = extractProperty(data, "commentLine")

  return (
    <Container>
      <StyledWrapper>
        <StyledDiv>
          <StyledRightDiv>
            <NewText
              component={"h2"}
              desktopFontSize={32}
              desktopLineHeight={"36px"}
              desktopFontWeight={400}
              mobileFontSize={24}
              mobileLineHeight={"28px"}
              color={sharedColors.black}
            >
              {title}
            </NewText>
            <NewText
              component={"p"}
              desktopFontSize={18}
              desktopLineHeight={"26px"}
              desktopFontWeight={400}
              mobileFontSize={16}
              mobileLineHeight={"23px"}
              color={sharedColors.black}
            >
              {textUnderTitle}
            </NewText>
          </StyledRightDiv>
          {/* <StyledLeftDiv>
            <StyledTabs value={value} onChange={handleChange}>
              <Tab
                key={"tab" + "0"}
                label={t("acc_development")}
                {...a11yProps(0)}
              />
              <Tab
                key={"tab" + "1"}
                label={t("acc_projects")}
                {...a11yProps(1)}
              />
            </StyledTabs>
          </StyledLeftDiv> */}
        </StyledDiv>
        <TabPanel value={value} index={0}>
          <TzabarPie data={pieGraphItems} commentLine={commentLine} tooltipRef={tooltipRef} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <TzabarLineChart data={pieGraphItems} tooltipRef={tooltipRef} />
        </TabPanel>
      </StyledWrapper>
    </Container>
  )
}

export default TzabarGraph
